// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelOra {
  font-size: x-large;
  margin-top: -10px;
  margin-bottom: 10px;
}

.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-left: 15px;
  width: 95%;
}

.infoText {
  font-size: small;
}`, "",{"version":3,"sources":["webpack://./src/app/elenco-presenti/modifica-presenza/modifica-presenza.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":[".labelOra {\n    font-size: x-large;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.footer {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n    margin-left: 15px;\n    width: 95%;\n}\n\n.infoText {\n    font-size: small; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
